import { IconFn, IconSvg } from "../createIcon";

export const SuccessIcon: IconFn = ({ color = "#BCCCDD", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 100, height: 100 }} {...props}>
    <path
      d="M50 93.75a43.75 43.75 0 1 1 0-87.5 43.75 43.75 0 0 1 0 87.5Zm0 6.25A50 50 0 1 0 50 0a50 50 0 0 0 0 100Z"
      fill={color}
    />
    <path
      d="M68.561 31.062a1.454 1.454 0 0 0-.125.137L46.73 58.855 33.649 45.768a4.687 4.687 0 0 0-6.625 6.625L43.56 68.937a4.687 4.687 0 0 0 6.744-.125l24.95-31.188a4.688 4.688 0 0 0-6.694-6.562Z"
      fill={color}
    />
  </IconSvg>
);
